/**
 * @file コンポーネント：フル動画ページ概要 スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { mediaQuery } from "~/src/styles/mixins";

// スタイル
export const StyledContent = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 8px 8px 12px;
    overflow-y: auto;
`;

export const StyledContentDevice = styled.div``;

export const StyledContentDeviceAnchor = styled.a`
    display: inline-flex;
    color: #acadae;
`;

export const StyledContentDeviceIcon = styled.span`
    margin-right: 4px;
`;

export const StyledContentDeviceName = styled.span``;

export const StyledContentEdit = styled.p`
    text-align: right;
`;

export const StyledContentEditLink = styled.a`
    color: #eed393;
    font-size: 11px;
    line-height: 16px;
`;

export const StyledContentEditLinkIcon = styled.span`
    margin-right: 4px;
`;

export const StyledContentEditLinkText = styled.span``;

export const StyledContentItem = styled.div`
    margin-bottom: 8px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const StyledContentParagraph = styled.p`
    margin-bottom: 8px;
    color: #ffffff;
    font-size: 12px;
    line-height: 14px;

    ${mediaQuery.pc(`
        font-size: 14px;
        line-height: 20px;
    `)};
 
    ${mediaQuery.pcWide(`
        font-size: 14px;
        line-height: 20px;
    `)};

    &:last-child {
        margin-bottom: 0;
    }
`;

export const StyledContentSection = styled.section`
    margin-top: 16px;
`;

export const StyledContentSectionHeadline = styled.h3`
    margin-bottom: 8px;
    color: #ffffff;
    font-weight: bold;
    font-size: 12px;
    line-height: 14px;

    ${mediaQuery.pc(`
        font-size: 14px;
        line-height: 20px;
    `)};
 
    ${mediaQuery.pcWide(`
        font-size: 14px;
        line-height: 20px;
    `)};
`;
